import { BoxV2 as Box, Flex, RoleGuard, SxProps } from 'portal-commons';
import { FC } from 'react';
import { faPen, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Role } from '../../../../../types/user';
import { User } from '../../types';
import { dateValueToText, roleEnumToLabel } from '../../utils';

interface UserListingRowProps {
  user: User;
  onEdit?: () => void;
  onDelete?: () => void;
}

const TableCell: FC<{ 'data-testid'?: string; sx?: SxProps }> = ({
  'data-testid': dataTestId,
  sx,
  children,
}) => {
  return (
    <Box
      as="td"
      data-testid={dataTestId}
      sx={{
        color: '#4D5659 !important',
        width: 'fit-content',
        maxWidth: '201px',
        wordBreak: 'keep-all',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

const IconWrapper: FC = ({ children }) => {
  return (
    <Flex
      sx={{
        height: 20,
        width: 20,
        color: '#333E41',
        fontWeight: 400,
        fontSize: '16px',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      {children}
    </Flex>
  );
};

const UserListingRow: FC<UserListingRowProps> = ({
  user,
  onEdit,
  onDelete,
}) => {
  return (
    <Box as="tr" data-testid="userListingRow">
      <TableCell data-testid="fullName">{user.profile.fullName}</TableCell>
      <TableCell data-testid="email">{user.profile.email}</TableCell>
      <TableCell data-testid="id">{user.id}</TableCell>
      <TableCell data-testid="role">
        {(user.profile.csp_app_role?.[0] &&
          roleEnumToLabel(user.profile.csp_app_role?.[0])) ||
          roleEnumToLabel(Role.Viewer)}
      </TableCell>
      <TableCell data-testid="created">
        {dateValueToText(user.created)}
      </TableCell>
      <TableCell data-testid="lastLogin">
        {dateValueToText(user.lastLogin)}
      </TableCell>
      <TableCell data-testid="userActions" sx={{ pr: '16px !important' }}>
        <Flex
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          <RoleGuard feature="profile.editUser">
            <IconWrapper>
              <FontAwesomeIcon
                icon={faPen}
                onClick={onEdit}
                data-testid="editUserButton"
              />
            </IconWrapper>
          </RoleGuard>
          <RoleGuard feature="profile.deleteUser">
            <IconWrapper>
              <FontAwesomeIcon
                icon={faTrash}
                onClick={onDelete}
                data-testid="deleteUserButton"
              />
            </IconWrapper>
          </RoleGuard>
        </Flex>
      </TableCell>
    </Box>
  );
};

export default UserListingRow;
